module.exports = __webpack_public_path__ + "static/media/gifi2.d62a36d9.jpg";